import { SplashScreen } from '@capacitor/splash-screen';
import { isNativePlatform } from './platformService.js';

let hidden = false;

export async function hideSplashWhenReady() {
  if (!isNativePlatform() || hidden) return;
  hidden = true;
  try {
    await SplashScreen.hide();
  } catch {
    hidden = false;
  }
}
